import { useNavigate, useLocation } from "react-router-dom";
import { getEmbeddedAnalyticsUrl } from '../../libs/fetch.js';
import { useAuthContext } from '../../contexts/AuthContext.jsx'; // Updated import to match context usage
import Loading from '../../components/Loading.jsx';
import { useEffect, useState } from 'react';
import posthog from 'posthog-js';

export default function DashboardEmbed() {
  const { currentOrganization, organization } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [iframeUrl, setIframeUrl] = useState('');
  const [iframeLoading, setIframeLoading] = useState(true);

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const embedId = pathSegments[pathSegments.length - 1];

  useEffect(() => {
    posthog.capture('$pageview');
  }, []);

  useEffect(() => {
    const fetchEmbeddedUrl = async () => {
      const availableEmbedsIds = organization?.available_embeds?.map((embed) => embed.id) ?? [];
      if (currentOrganization && embedId && availableEmbedsIds.includes(Number(embedId))) {
        const url = await getEmbeddedAnalyticsUrl(currentOrganization, embedId);
        setIframeUrl(url);
        if (!url) {
          navigate('/home');
        }
      } else {
        navigate('/home');
      }
    };

    fetchEmbeddedUrl();
  }, [currentOrganization, embedId]);

  return (
    <>
      {!iframeUrl ? <Loading /> :
        <>
          {iframeLoading ? <Loading /> : null}
          <iframe
            src={iframeUrl}
            width="100%"
            style={{ height: '92vh', display: iframeLoading ? 'none' : 'block' }}
            onLoad={() => setIframeLoading(false)}
          ></iframe>
        </>
      }
    </>
  );
}

